import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../common/html/checkbox'
import { Element } from '../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../../routers/constants'
import { LinkComponent } from '../../../../common/html/LinkComponent'
import { changeDetailsSuggest, selectSuggest } from '../../store/slice'

export const CustomTdCheckBox = ({ val, rowId }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectSuggest([rowId, 'check']))
  const data = useSelector(selectSuggest())
  const isCanNavigate = Object.values(data).some((item) => item?.check)

  //Actions
  const handleCheck = () => {
    dispatch(
      changeDetailsSuggest({
        path: ['dataDetailsSuggest', rowId, 'check'],
        data: !checked,
      }),
    )
  }

  return (
    <div className="dFlex">
      <Checkbox
        styleIcon={{ padding: '4px 12px' }}
        checked={checked}
        onChange={handleCheck}
      />
      {!isCanNavigate ? (
        <>
          <LinkComponent
            href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${rowId}`}
          >
            <Element
              style={{
                padding: '4px 0',
                paddingRight: 12,
                cursor: 'default',
                color: '#2C73E8',
              }}
            >
              <TextEllipsisStaticLine text={val} isI18n={false} />
            </Element>
          </LinkComponent>
        </>
      ) : (
        <Element
          className="cursorPointer"
          style={{ padding: '4px 0', paddingRight: 12, color: '#2C73E8' }}
          onClick={handleCheck}
        >
          <TextEllipsisStaticLine text={val} isI18n={false} />
        </Element>
      )}
    </div>
  )
}
